/* eslint no-underscore-dangle: 0 */
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TableSortLabel } from '@mui/material';
import Chip from 'ui-component/extended/Chip';

// import DeleteIcon from '@mui/icons-material/Delete';
// import EditIcon from '@mui/icons-material/Edit';

import { Box } from '@mui/system';
import { visuallyHidden } from '@mui/utils';
import Spinner from 'components/spinner';
import { headCells } from 'constants/promoCodeManagement';
import dayjs from 'dayjs';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setSort } from 'store/slices/table';
import { ActionMenu } from '../actionMenu';

type Sort = { order: string; orderBy: string } | null;
type PromoCodeTableProps = {
    promoCodeList: any;
    // handleEdit: (event: React.MouseEvent<HTMLButtonElement, MouseEvent> | null, id: string) => void;
    handleRefetch: () => void;
    loading: any;
};

type Order = 'asc' | 'desc';
const PromoCodeTemplate = ({ promoCodeList /*handleEdit ,*/, handleRefetch, loading }: PromoCodeTableProps) => {
    const dispatch = useDispatch();
    const {
        sort: { order, orderBy }
    } = useSelector((state: any) => state.table);

    useEffect(() => {
        handleRefetch();
    }, [order, orderBy]);

    const handleRequestSort = (event: React.MouseEvent<unknown>, property: any) => {
        const isAsc = orderBy === property && order === 'asc';
        const setOrder = isAsc ? 'desc' : 'asc';
        dispatch(setSort({ order: setOrder, orderBy: property }));
    };

    if (loading) {
        return <Spinner />;
    }

    return (
        <>
            <TableContainer>
                <Table sx={{ minWidth: 750 }} aria-labelledby="tableTitle">
                    <TableHead>
                        <TableRow>
                            {headCells.map((headCell) => {
                                if (headCell.id === 'action') {
                                    return (
                                        <TableCell
                                            key={headCell.id}
                                            align={headCell.align}
                                            padding={headCell.disablePadding ? 'none' : 'normal'}
                                        >
                                            {headCell.label}
                                        </TableCell>
                                    );
                                }
                                return (
                                    <TableCell
                                        key={headCell.id}
                                        align={headCell.align}
                                        padding={headCell.disablePadding ? 'none' : 'normal'}
                                        sortDirection={orderBy === headCell.id ? order : false}
                                    >
                                        <TableSortLabel
                                            active={orderBy === headCell.id}
                                            direction={orderBy === headCell.id ? order : 'asc'}
                                            onClick={(event) => handleRequestSort(event, headCell.id)}
                                        >
                                            {headCell.label}
                                            {orderBy === headCell.id ? (
                                                <Box component="span" sx={visuallyHidden}>
                                                    {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                                                </Box>
                                            ) : null}
                                        </TableSortLabel>
                                    </TableCell>
                                );
                            })}
                        </TableRow>
                    </TableHead>

                    {/* table body */}
                    <TableBody>
                        {!promoCodeList?.length ? (
                            <TableRow sx={{ borderBottom: 'none' }}>
                                <TableCell align="center"> </TableCell>
                                <TableCell align="center"> </TableCell>
                                <TableCell align="center">
                                    {' '}
                                    <h1>No Items</h1>
                                </TableCell>
                                <TableCell align="center"> </TableCell>
                                <TableCell align="center"></TableCell>
                                <TableCell align="center"></TableCell>
                            </TableRow>
                        ) : (
                            <>
                                {promoCodeList.map((promoCode) => (
                                    <TableRow key={promoCode._id}>
                                        <TableCell align="center">{promoCode.title}</TableCell>
                                        <TableCell align="center">{promoCode.code}</TableCell>
                                        <TableCell align="center">
                                            {promoCode.promoDuration == 'once' || promoCode.promoDuration == 'indefinite'
                                                ? promoCode.promoDuration
                                                : promoCode.promoDuration + ' month'}
                                        </TableCell>

                                        <TableCell align="center">
                                            {promoCode.promoMethod === 'Percent'
                                                ? promoCode.promoAmount + '%'
                                                : '$' + promoCode.promoAmount}
                                        </TableCell>
                                        <TableCell align="center">{promoCode.promoCodeUsed ? promoCode.promoCodeUsed : 0}</TableCell>
                                        <TableCell align="center">{dayjs(promoCode.createdAt).format('D MMMM YYYY')}</TableCell>
                                        <TableCell align="center">
                                            {promoCode.status === 'active' && (
                                                <Chip
                                                    label={promoCode.status?.charAt(0).toUpperCase() + promoCode.status?.slice(1)}
                                                    size="medium"
                                                    chipcolor="success"
                                                />
                                            )}

                                            {promoCode.status === 'inactive' && (
                                                <Chip
                                                    label={promoCode.status?.charAt(0).toUpperCase() + promoCode.status?.slice(1)}
                                                    size="medium"
                                                    chipcolor="orange"
                                                />
                                            )}
                                        </TableCell>
                                        <TableCell align="center" sx={{ pr: 3 }}>
                                            <ActionMenu promoCode={promoCode} handleRefetch={handleRefetch} />
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </>
                        )}
                    </TableBody>
                </Table>
            </TableContainer>
        </>
    );
};

export default PromoCodeTemplate;
